import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { BrameCampaign } from 'api/brameCampaigns'
import { ReactComponent as GamesIcon } from 'assets/images/ic-games.svg'
import PopoverMenu, { PopoverOption } from 'components/PopoverMenu'
import { buildTranslate } from 'locales'
import React from 'react'

interface GameCardProps {
  game: BrameCampaign
  onAddToHomepage?: () => void
  onMenuAction?: (gameId: string, action: string) => void
  homepageStatus?: { exists: boolean; blockId?: number }
}

const GameCard = ({
  game,
  onAddToHomepage,
  onMenuAction,
  homepageStatus,
}: GameCardProps) => {
  const t = buildTranslate('games')
  const isOnHomepage = homepageStatus?.exists ?? false
  const buttonText = isOnHomepage
    ? t('enabled.collection.gameCard.viewOnHomepage')
    : t('enabled.collection.gameCard.addToHomepage')

  return (
    <div
      className="bg-white border p-4 rounded"
      style={{
        border: '1px solid #e9eaec',
        borderRadius: '4px',
      }}
    >
      <div className="d-flex align-items-center" style={{ gap: '16px' }}>
        <div
          className="flex-shrink-0 d-flex align-items-center justify-content-center"
          style={{
            width: '48px',
            height: '48px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9eaec',
            borderRadius: '4px',
          }}
        >
          <GamesIcon
            style={{
              width: '30px',
              height: '24px',
              fill: '#6a747f',
            }}
          />
        </div>

        <div className="flex-grow-1">
          <div className="mb-1">
            <Text.BodyText3 color="#36424e" className="fw-bold">
              {game.name}
            </Text.BodyText3>
          </div>
          <div>
            <Text.BodyText4 color="#6a747f">{game.campaign_url}</Text.BodyText4>
          </div>
        </div>

        <div className="d-flex align-items-center" style={{ gap: '16px' }}>
          <PopoverMenu
            placement="bottomRight"
            dismissOnClickOutside={true}
            closeOnClick={true}
            ariaLabel={t('enabled.collection.gameCard.openMenu')}
          >
            <PopoverOption onClick={() => onMenuAction?.(game.id, 'edit')}>
              Edit
            </PopoverOption>
            <PopoverOption onClick={() => onMenuAction?.(game.id, 'delete')}>
              Delete
            </PopoverOption>
          </PopoverMenu>

          <Button
            kind={isOnHomepage ? 'secondary' : 'primary'}
            size="small"
            onClick={() => onAddToHomepage?.()}
            $style={
              isOnHomepage
                ? {
                    border: '2px solid #28a745',
                    color: '#28a745',
                    backgroundColor: 'transparent',
                    padding: '7px 16px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  }
                : undefined
            }
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default GameCard
